<script>
export default {
  props: {
    buttons: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    buttonStyle(button, data = {}) {
      switch (button.style) {
        case 'primary-outline':
          return 'button is-primary is-rounded is-outlined is-fullwidth';
        case 'primary':
          return 'button is-primary is-rounded is-fullwidth';
        case 'black':
          return 'button is-black is-fullwidth is-rounded is-outlined';
        default:
          return 'button is-primary is-rounded is-fullwidth';
      }
    },
    buttonShow(button) {
      return button.if === undefined || button.if;
    },
    buttonDisabled(button) {
      return 'disabled' in button ? button.disabled : false;
    },
    buttonLink(button) {
      return button.to || '';
    },
    buttonClick(button) {
      return button.fn() || '';
    }
  }
}
</script>

<template>
  <div class="buttons" :class="$style.baseButton">
    <template v-for="(button, index) in buttons">
      <!--Type: Link-->
      <template v-if="button.type === 'link'">
        <router-link
          v-if="buttonShow(button)"
          :key="index"
          :disabled="buttonDisabled(button)"
          :class="buttonStyle(button)"
          :to="buttonLink(button)"
        >
          <span v-html="button.textFormat && typeof button.textFormat === 'function' ? button.textFormat() : button.text"></span>
        </router-link>
        <!--提示文字-->
        <div
          v-if="buttonShow(button) && button.disabled && button.meta && button.meta.disabledTip"
          :key="`${index}disabledTip`"
          :class="$style.buttondDisabledTip"
        >
          {{button.meta.disabledTip}}
        </div>
      </template>

      <!--Type: Button-->
      <template v-if="button.type === 'button'">
        <b-button
          v-if="buttonShow(button)"
          :key="index"
          :disabled="buttonDisabled(button)"
          :class="buttonStyle(button)"
          :loading="button.loading"
          @click="buttonClick(button)"
        >
          <span v-html="button.textFormat && typeof button.textFormat === 'function' ? button.textFormat() : button.text"></span>
        </b-button>
      </template>

      <!--Type: A-->
      <template v-if="button.type === 'a'">
        <a
          v-if="buttonShow(button)"
          :key="index"
          :disabled="buttonDisabled(button)"
          :class="buttonStyle(button)"
          :href="buttonLink(button)"
          target="_blank"
        >
          <span v-html="button.textFormat && typeof button.textFormat === 'function' ? button.textFormat() : button.text"></span>
        </a>
      </template>
    </template>
  </div>
</template>

<style lang="scss" module>
  .baseButton {

  }
  .buttondDisabledTip {
    width: 100%;
    margin-top: -15px;
    margin-bottom: 15px;
    font-size: 13px;
    color: rgb(147, 40, 43);
    text-align: center;
  }
</style>
